import { cloudChiprApiAccountService } from "@/services/cloudchipr-account-service.api";
import { RootState } from "@/store/store";

const endpoint =
  cloudChiprApiAccountService.endpoints
    .getOrganisationQuarterStartMonthByIdFromAccountService.select;

export const internalOrgQuarterStartMonthSelector = (
  state: RootState,
  organisationId: string,
): number | undefined => {
  return endpoint({ organisationId })(state)?.data;
};
